<template>
    <div class="container container--echeancier-list">

        <Loader v-if="!isReady"></Loader>

        <List v-else
            :filtering="this"
            :itemNameSingular="'échéance'"
            :itemNamePlural="'échéances'">

            <template v-slot:actions>
                    
                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>
                    
            </template>


            <template v-slot:filters>

                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher un n°, facture, etc."/>
                </ListFilter>
                <ClientFilter v-model="filters.client_id"
                    :clients="clients"/>
                <ListFilter class="filter">
                    <Select v-model="filters.status"
                        :options="status"
                        all="Acquitté / Non Acquitté">
                    </Select>
                </ListFilter>
                <DateFilter v-model="dates" />

            </template>

            <template v-slot:heading>
                <div class="cell cell--main criteria">
                    <Sorter criteria="num">Numéro</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="pieceType">Pièce</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="pieceNum">N° pièce</Sorter>
                </div>
                <div class="cell criteria">
                    <Sorter criteria="endAt">Échéance le</Sorter>
                </div>
                <div class="cell">
                    Acquitté
                </div>
                <div class="cell criteria">
                    <Sorter criteria="amountTTC">Restant / Total TTC</Sorter>
                </div>
                <div class="cell actions--actions">
                    Actions
                </div>
            </template>
            
            <!--<template v-slot:actions>
                 <a class="woocommerce-button button alt"
                    href="#" 
                    v-on:click="payAll()">Payer l'intégralité</a> 
            </template> -->

            <ul class="list__content echeancier-list" v-if="hasContent">

                <li class="list__content__item"
                    v-for="echeancier in items"
                    :key="echeancier.id">        

                    <ListItem class="list-item--card"
                        :item="echeancier"
                        :route="route">

                        <div class="cell cell--main">
                            <strong>{{ echeancier.num }}</strong>
                        </div>
                        <div class="cell cell--secondary">{{ echeancier.pieceTypeLibelle }}</div>
                        <div class="cell cell--secondary">{{ echeancier.pieceNum }}</div>
                        <div class="cell cell--date"><Date :date="echeancier.endAt" /></div>
                        <div class="cell cell--state">
                            <Badge type="success" v-if="echeancier.isAcquitte">Oui</Badge>
                            <Badge type="warning" v-if="!echeancier.isAcquitte">Non</Badge>
                        </div>
                        <div class="cell"><Price :amount="echeancier.amountRemaining" :currency="echeancier.currency" /> / <Price :amount="echeancier.amountTTC" :currency="echeancier.currency" /></div>
                        <div class="cell cell--actions">
                            <button class="woocommerce-button button alt"
                                type="button"
                                v-if="!echeancier.isAcquitte"
                                @click="$event.preventDefault(); pay(echeancier)">Payer</button>
                        </div>
                    </ListItem>

                </li>

            </ul>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les échéances suivantes</button>
            </div>
            
            <div class="container_list container_list--no-result" v-if="items.length == 0">
                <h1 class="woocommerce-order-details__title">Aucune échéance</h1>
            </div>
                        
        </List>

    </div>
</template>

<script>
import { mapState } from 'vuex'

import { goTo } from '@/router'

import Badge from '@/components/badge/Badge.vue'
import Button from '@/components/button/Button.vue'
import ClientFilter from '@/components/list/filters/ClientFilter.vue'
import Date from '@/components/date/Date.vue'
import DateFilter from "@/components/list/filters/DateFilter.vue"
import List, { ListFilter, ListItem, Sorter }  from '@/components/list/List.vue'
import Loader from '@/components/loader/Loader.vue'
import Price from '@/components/price/Price.vue'
import Select  from '@/components/select/Select.vue'

import api from '@/api/proxyWeb/echeanciers'
import { routes } from '@/router'

import filtering from "@/containers/filtering";

export default {

    name: 'EcheancierList',

    data: function() {
        return {
            filters: {
                client_id: null,
                from: null,
                to: null,
                query: '',
                status: null
            },
            route: routes.ECHEANCIER,
            processingXlsx: false
        }
    },

    computed: {

        status: () => {
            return [
                { value: 'acquitte', name: 'Oui' },
                { value: 'no_acquitte', name: "Non" }
            ] 
        },
        
        ...mapState({

            clients: state => state.clients.all,

            clientAddresses: function(state) {

                if ( !state.clients.all ) {
                    return []
                }

                let clientAddresses = []
                state.clients.all.forEach(client => {
                    if ( !this.filters.client_id ) {
                        clientAddresses = [ ...clientAddresses, ...client.clientAddresses ]
                    }
                    else if ( client.id == this.filters.client_id ) {
                        clientAddresses = client.clientAddresses
                    }
                });

                return clientAddresses
            },

            markets: state => state.sites.markets,
        })
    },

    methods: {

        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        }, 
        
        pay: function(echeancier) {
            goTo('/wp-content/plugins/myAdelya/tasks/purchase/echeanciers/' + echeancier.id)
        },

        payAll: function() {
            alert('TODO Paiement totalité')
            // goTo('/wp-content/plugins/myAdelya/tasks/purchase/echeancier/' + echeancier.id)
        }
    },
  
    created () {
        this.useFilter(api)
    },

    components: {
        Badge,
        Button,
        ClientFilter,
        Date,
        DateFilter,
        List,
        ListFilter,
        ListItem,
        Loader,
        Price,
        Select,
        Sorter
    },

    mixins: [ filtering ]
}
</script>
